// SiteUp — Modo Foco: hub de entrada (Parte 3).
import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions';
import HubView from './HubView.vue';
import HubWorldHome from './HubWorldHome.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/hub'),
    name: 'focus_hub',
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
    component: HubView,
  },
  // Tela de início de uma área (Atender, Vender, Ações de Marketing,
  // Automações): opções da área e os números do dia.
  {
    path: frontendURL('accounts/:accountId/hub/:worldId'),
    name: 'hub_world_home',
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
    component: HubWorldHome,
  },
];
